
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_11n0s_19rdy_5",
  "empty": "awsui_empty_11n0s_19rdy_9"
};
  